var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowseCatalogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0L13 5V16L18 11.5V0ZM0 5V19.65C0 19.9 0.25 20.15 0.5 20.15C0.6 20.15 0.65 20.1 0.75 20.1C2.1 19.45 4.05 19 5.5 19C7.45 19 9.55 19.4 11 20.5V5C9.55 3.9 7.45 3.5 5.5 3.5C3.55 3.5 1.45 3.9 0 5ZM22 18.5V5C21.4 4.55 20.75 4.25 20 4V17.5C18.9 17.15 17.7 17 16.5 17C14.8 17 12.35 17.65 11 18.5V20.5C12.35 19.65 14.8 19 16.5 19C18.15 19 19.85 19.3 21.25 20.05C21.35 20.1 21.4 20.1 21.5 20.1C21.75 20.1 22 19.85 22 19.6V18.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseCatalogs);
export default __webpack_public_path__ + "static/media/browse-catalogs.fee80747.svg";
export { ForwardRef as ReactComponent };